// extracted by mini-css-extract-plugin
export var aiStarSpin = "_n0-1";
export var spinner = "_n0-0";